import React from "react";
import { ToastContainer } from "react-toastify";

const InventoryViewModal = ({
  detailModalOpen,
  setDetailModalOpen,
  detailItem,
  getDishLabel,
}) => {
  return (
    <>
    <ToastContainer/>
    
      {/* view details modal */}

      {detailModalOpen &&
        detailItem &&
        (() => {
          const dish = getDishLabel(detailItem);

          return (
            <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 montserrat-font-1">
              <div className="bg-white w-[950px] max-h-[90vh] rounded-xl shadow-xl flex flex-col overflow-hidden montserrat-font-1">
                {/* CLOSE */}
                <div className="flex-1 overflow-y-auto px-6 pb-6">
               <div className="sticky top-0 z-20 bg-white border-b px-6 py-4 flex justify-between items-center">
  <h2 className="text-xl font-semibold text-gray-800">
    {detailItem.item_name}
  </h2>

  <button
    onClick={() => setDetailModalOpen(false)}
    className="text-gray-500 hover:text-black"
  >
    ✕
  </button>
</div>

                {/* TOP SECTION */}
                <div className="grid grid-cols-3 gap-5 mb-6">
                  {/* IMAGE */}
                  <div className="w-full">
                    <img
                      src={detailItem.photo}
                      className="w-full h-[150px] object-contain rounded-xl"
                    />
                  </div>

                  {/* STATUS + PRICE */}
                  <div className="space-y-4">
                    <div className="border rounded-xl p-3 bg-gray-50">
                      <p className="text-xs text-gray-400 mb-1">Status</p>

                      <span className="inline-flex items-center px-3 py-1 text-sm rounded-full bg-emerald-100 text-emerald-700">
                        Active
                      </span>
                    </div>

                    <div className="border rounded-xl p-3 bg-gray-50">
                      <p className="text-xs text-gray-400 mb-1">Price</p>
                      <p className="font-medium">₹{detailItem.price}</p>
                    </div>
                  </div>

                  {/* CATEGORY + DISH */}
                  <div className="space-y-4">
                    {/* CATEGORY */}
                    <div className="border rounded-xl p-3 bg-gray-50">
                      <p className="text-xs text-gray-400 mb-1">Category</p>
                      <p className="font-medium">{detailItem.category_name}</p>
                    </div>

                    {/* ICON DISH */}
                    {dish && (
                      <div className="border rounded-xl p-2 bg-gray-50">
                        <p className="text-xs text-gray-400 mb-2">Icon Dish</p>

                        <div className="flex items-center gap-2">
                          <span className="flex items-center gap-2 border rounded-full px-3 py-1 text-sm">
                            <img
                              src={JSON.parse(detailItem.icon_dish || "[]")[0]}
                              className="w-5 h-5"
                            />
                            {dish.label}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* DETAILS GRID */}

                <div className="grid grid-cols-2 gap-4">
                  {[
                    ["Item Id", detailItem.item_id || "—"],
                    ["Id", detailItem.id || "—"],
                    ["Item Name", detailItem.item_name || "—"],
                    ["Status", detailItem.status === "Y" ? "Yes (Y)" : "No"],
                    ["InStock", detailItem.inStock === "Y" ? "Yes (Y)" : "No"],
                    ["Price", detailItem.price || "—"],
                    ["Discount", detailItem.discount || "—"],
                    ["Discount Price", detailItem.discount_price || "—"],
                    ["Category Name", detailItem.category_name || "—"],
                    ["Sub Category", detailItem.sub_category || "—"],
                    ["Size", detailItem.size || "—"],
                    ["Size Id", detailItem.size_id || "—"],
                    ["Item Category", detailItem.item_category || "—"],
                    ["Stock", detailItem.stock || "—"],
                    [
                      "Home Delivery",
                      detailItem.home_delivery === "Y" ? "Yes" : "No",
                    ],
                    ["Takeaway", detailItem.takeaway === "Y" ? "Yes" : "No"],
                    ["Dining", detailItem.dining === "Y" ? "Yes" : "No"],
                    ["BarcodeNumber", detailItem.barcodeNumber || "—"],
                    ["Item Description", detailItem.item_description || "—"],
                    [
                      "Dish",
                      (() => {
                        try {
                          const dish = JSON.parse(detailItem.dish || "[]")[0];
                          return (
                            <span className="inline-flex items-center justify-center w-6 h-6 rounded-full border text-xs font-medium">
                              {dish}
                            </span>
                          );
                        } catch {
                          return "—";
                        }
                      })(),
                    ],
                    ["Item Name trans", detailItem.item_name_trans || "—"],
                    [
                      "Item Description Trans",
                      detailItem.item_description_trans || "—",
                    ],
                    ["Category", detailItem.category || "—"],
                    ["rating", detailItem.ratings || "—"],
                    ["Size Trans", detailItem.size_trans || "—"],
                    ["Icon Dish", detailItem.icon_dish || "—"],
                    ["Position", detailItem.position || "—"],
                    ["Cat Id", detailItem.cat_id || "—"],
                    [
                      "Category Description",
                      detailItem.category_description || "—",
                    ],
                  ].map(([label, value], i) => (
                    <div key={i} className="border rounded-xl p-2 bg-gray-50">
                      <p className="text-xs text-gray-400 mb-1">{label}</p>
                      <p className="text-sm font-medium">{value}</p>
                    </div>
                  ))}
                </div>

                {/* FOOTER */}

                <div className="flex justify-end mt-6">
                  <button
                    onClick={() => setDetailModalOpen(false)}
                    className="border px-5 py-2 rounded-lg hover:bg-gray-100"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
            </div>
          );
        })()}
    </>
  );
};

export default InventoryViewModal;
